import CheckIcon from '@mui/icons-material/Check'
import { Autocomplete, Chip, TextField, useTheme } from '@mui/material'
import { useRef, useState } from 'react'
import { authorizedChipStyle } from '../ContractDialog/style'
import { renderUserOption } from '../Team/renderOptions'

const AuthorizedRecipientAutocomplete = ({
  recipients,
  value,
  label,
  onChange,
  error,
  isDraft,
  isCurrentRecipient,
}) => {
  const theme = useTheme()
  const [inputValue, setInputValue] = useState('')
  const [selectedUsers, setSelectedUsers] = useState(value || [])
  const inputRef = useRef(null) // To manage focus programmatically

  const handleSelectUser = (event, newValue) => {
    setSelectedUsers(newValue)
    onChange(newValue)
  }

  const handleRemoveUser = userId => {
    const newSelectedUsers = selectedUsers.filter(user => user.id !== userId)
    setSelectedUsers(newSelectedUsers)
    onChange(newSelectedUsers)
    if (inputRef.current) {
      inputRef.current.focus() // Keep the input focused
    }
  }

  return (
    <Autocomplete
      multiple
      id="authorized-recipients-autocomplete"
      disabled={!isDraft}
      options={recipients || []}
      getOptionLabel={option =>
        option.real_name
          ? option.real_name
          : `${option['First Name'] || option.firstName || option.first_name} ${
              option['Last Name'] || option.lastName || option.last_name
            } (${option['Employee Email'] || option.email})`
      }
      // value={selectedUsers}
      value={value}
      // onChange={handleSelectUser}
      onChange={(event, newValue) => onChange(newValue)}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterOptions={(options, { inputValue }) => {
        return options.filter(option =>
          option.real_name
            ? option.real_name
            : `${option['First Name'] || option.firstName || option.first_name} ${
                option['Last Name'] || option.lastName || option.last_name
              }`
                .toLowerCase()
                .includes(inputValue.toLowerCase())
        )
      }}
      renderOption={(props, option, state) => renderUserOption(props, option, state, theme)}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...rest } = getTagProps({ index })
          return (
            <Chip
              key={key}
              label={`${option['First Name'] || option.firstName || option.first_name} ${
                option['Last Name'] || option.lastName || option.last_name
              }`}
              {...rest}
              onDelete={() => handleRemoveUser(option.id || option.gusers_uuid)}
              sx={authorizedChipStyle(theme)}
              icon={isCurrentRecipient ? <CheckIcon /> : null}
            />
          )
        })
      }
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          error={error}
          placeholder={selectedUsers?.length > 0 ? 'Addtl Recipients' : 'Select Authorized Recipient'}
          inputRef={inputRef} // Attach the ref here
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none !important',
            },
            '& .MuiInputBase-input::placeholder': {
              color: theme.palette.text.secondary,
              fontStyle: 'italic',
            },
          }}
        />
      )}
      fullWidth
    />
  )
}

export default AuthorizedRecipientAutocomplete
